<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew' voltar='true' voltarUrl='/servicos/legislacao')
	.row(style='margin-bottom: 12px')
		.col-md-10
			.input-group
				input.form-control(type='text', v-model='searchQ', placeholder='Filtrar documentos por título…', @keyup.enter='applySearch')
				span.input-group-btn
					button.btn.btn-primary(type='button', @click='applySearch') Buscar
					button.btn.btn-default(type='button', v-if='appliedSearch', @click='clearSearch') Limpar
	p.text-muted(style='font-size: 12px; margin: -4px 0 12px') Estes itens são listados no portal em Legislação nesta categoria.
	vue-element-loading(:active='isActive' spinner='bar-fade-scale' color='#428BCA')
	grid(
		ref="grid"
		:key='urlDataSource'
		:url='urlDataSource'
		:columns='columns'
		:GridHeight="400"
		:GridPageable="true"
		:DSpageSize="8"
		:DSserverPaging="true"
		:DSschema="true"
		:DSschemaData="'data'"
		:DSschemaTotal="'total'"
		:DSschemaParse="parse"
		:GridPageablePageSizes="[1, 10, 20, 100]"
	)
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import TemplatesAbrir from './Templates/Abrir'
import TemplatesAcoes from './Templates/Acoes'
import Permission from '@/mixins/Permission'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'

export default {
	mixins: [Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid
	},
	data() {
		return {
			title: '',
			titleNew: '',
			url: this.$route.path + '/',
			searchQ: '',
			appliedSearch: '',
			columns: [{
				field: 'id',
				title: 'Id',
				width: 30
			}, {
				field: 'ano',
				title: 'Ano',
				width: 40
			}, {
				field: 'titulo',
				title: 'Título',
				width: 200
			}, {
				field: 'active_name',
				title: 'Ativo',
				width: 50
			}, {
				template: this.getTemplateAbrir,
				title: 'Opção',
				width: 40,
			}],
			isActive: false,
		}
	},
	computed: {
		urlDataSource() {
			const id = this.$route.params.id
			let u = `${this.$url}/v1/legislacao/categorias/${id}?offset=8`
			if (this.appliedSearch) {
				u += `&q=${encodeURIComponent(this.appliedSearch)}`
			}
			return u
		},
	},
	methods: {
		applySearch() {
			this.appliedSearch = (this.searchQ || '').trim()
		},
		clearSearch() {
			this.searchQ = ''
			this.appliedSearch = ''
		},
		parse(d) {
			d.data.map(i => {
				return i
			})
			return d
		},
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.splice(this.columns.length, 0, {
					template: this.getTemplateAcoes,
					title: 'Ações',
					width: 70,
				})
			}
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.titulo,'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if(result.isConfirmed) {
				this.isActive = true
				await req(`/v1/legislacao/categorias/${item.legislacao_categoria_id}/${item.id}`, 'delete').catch(response => {
					'error: ' + response
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		},
		getTemplateAcoes(e) {
			const vm = this
			return {
				template: TemplatesAcoes,
				templateArgs: {
					data: e,
					vm
				}
			}
		},
		getTemplateAbrir(e) {
			const vm = this
			return {
				template: TemplatesAbrir,
				templateArgs: {
					data: e,
					vm
				}
			}
		},
		async getDados() {
			const dados = await req(`/v1/legislacao/${this.$route.params.id}`)
			document.querySelector('.menu-selecionado').textContent = dados.titulo
			this.title = dados.titulo
		}
	},
	created() {
		this.getDados()
		this.verifPermissao()
	}
}
</script>

<style lang="stylus" scoped>

</style>
